<template>
  <!-- eslint-disable -->
  <div>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="srsCodes"
      :loading="loading"
    >
      <!-- srs code -->
      <template v-slot:item.srsNumber="{ item }">
        <v-menu
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
          transition="slide-x-transition"
          @input="onSrsCodeMenuInput"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-layout
              align-center
              class="app-hover-pointer"
              style="display: inline-block"
              v-bind="attrs"
              v-on="on"
            >
              <span class="mr-2">{{ item.srsNumber }}</span>
              <v-icon class="ma-0">mdi-pencil</v-icon>
            </v-layout>
          </template>
          <v-card max-width="400px">
            <v-card-text>
              <h3 class="text-truncate mt-2 mb-6">{{ item.itemNo }} -</h3>
              <v-text-field
                filled
                readonly
                label="Current Srs Code"
                v-model="item.srsNumber"
              />
              <v-text-field
                filled
                :disabled="savingSrsCode == true"
                hide-details
                label="New Srs Code"
                v-model="newSrsCode"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :disabled="!isNewSrsCodeValid || savingSrsCode == true"
                :loading="savingSrsCode"
                text
                @click="onSaveSrsCodeClicked(item)"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-menu> </template
      ><!-- srs code -->
    </v-data-table>

    <v-dialog max-width="370" v-model="dialogOpened">
      <v-card>
        <v-card-text class="pa-0">
          <v-alert class="ma-0" text type="success">
            The SRS Code change has been queued!
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api";
/* eslint-disable */
import timers from "../../utils/timers";
import toasts from "../../utils/toasts";

export default {
  props: {
    srsCodes: {
      type: Array, // SrsCodeStockItem[]
    },
    loading: {
      type: Boolean,
      default: false,
    },
  }, // props

  data: () => ({
    headers: [
      {
        text: "SRS Code",
        value: "srsNumber",
      },
      {
        text: "Supplier ID",
        value: "internalId",
      },
      {
        text: "Supplier Name",
        value: "supplierName",
      },
      {
        text: "Location",
        value: "location",
      },
      {
        text: "Product Code",
        value: "itemNo",
      },

      {
        text: "Company",
        value: "company",
      },
      {
        text: "",
        value: "action",
      },
    ],
    newSrsCode: "",
    savingSrsCode: false,
    dialogOpened: false,
  }), // data

  computed: {
    isNewSrsCodeValid() {
      return (
        this.newSrsCode != undefined &&
        this.newSrsCode != null &&
        this.newSrsCode.trim().length > 0
      );
    },
  }, // computed

  methods: {
    onSrsCodeMenuInput() {
      this.newSrsCode = "";
    },

    async onSaveSrsCodeClicked(itemNo) {
      if (!this.isNewSrsCodeValid) return;

      try {
        this.savingSrsCode = true;

        await timers.wait(1000);
        await api.srsCodes.update({
          newSrsCode: this.newSrsCode,
          stockItemInternalId: itemNo.srsNumber,
          itemNo: itemNo.itemNo,
        });

        this.dialogOpened = true;

        this.srsCodes.forEach((x) => {
          if (x.itemNo == itemNo) {
            x.srsCode = this.newSrsCode;
          }
        });
      } finally {
        this.savingSrsCode = false;
      }
    },
  }, // methods
};
</script>
